module.exports = __webpack_public_path__ + "img/Icon-download.d4929044.svg";